export default __webpack_public_path__ + "static/media/charity-donation-hand-love.41d265c2.svg";